export const calcEn_schema = (value, minAmount = 0, maxAmount, page) => {
  if (
    (maxAmount == null || maxAmount === 0)
  ) {
    return { valid: true, message: "" }; 
  }
  if (page === "manasik") {
    if (value >= minAmount && value <= maxAmount) {
      return { valid: true, message: "" };
    } else {
      return {
        valid: false,
        message: `Please enter a value between ${minAmount} and ${maxAmount}`,
      };
    }
  } else {
    if (value <= maxAmount) {
      return { valid: true, message: "" };
    } else {
      return {
        valid: false,
        message: `Please enter a value less than or equal to ${maxAmount}`,
      };
    }
  }
};
